import moment from 'moment';
import { LAST_MONTH_IN_YEAR, MONTHS_IN_YEAR } from '../constants/months';

export default ((monthsCount) => {
  const currentMonth = moment().month() + 1;
  const monthsMap = new Map();

  let monthNumber = monthsCount > currentMonth ?
  MONTHS_IN_YEAR - (monthsCount - currentMonth) :
  currentMonth - monthsCount;


  for (let j = 0; j < monthsCount; j += 1) {
    monthsMap.set(monthNumber, []);

    monthNumber = monthNumber === LAST_MONTH_IN_YEAR ? 0 : monthNumber + 1;
  }

  return monthsMap;
});